<template>
  <div class="content">
    <div style="text-align: center;display:flex;align-items: center;width: 100%;"
         :style="{'height': loaderHeight + 'px'}" v-if="isLoading">
      <div style="margin:0 auto">
        <img class="rounded" width="100px" src="static/loader-gif.gif"/>
        <br/>
        {{$t('message.loadingText')}}
      </div>
    </div>
    <mu-row gutter>
      <div class="noFavourites" v-show="recipeData.recipes.length == 1000">
        <p>You haven't added any recipes to your favourites yet, have a browse!</p>
      </div>
      <mu-col class="bottom" v-for="item, recipeI in recipeData.recipes" v-if="recipeData.recipes.length < 1000" :key="'recipe-' + recipeI" width="100"
              desktop="33" tablet="33">
        <recipe-card :recipe="item"></recipe-card>
      </mu-col>
    </mu-row>
  </div>
</template>

<script>
  import RecipeApi from '../../api/Recipes'
  import RecipeCard from "./Components/RecipeCard";

  import $ from 'jquery';


  export default {
    components: {RecipeCard},
    name: "recipe-favorites",
    data() {
      return {
        isLoading: true,
        recipeData: {
          recipes: []
        },
        loaderHeight: 0
      }
    },
    mounted() {
      let self = this;
      self.getFavorites();
      const loaderHeight = $('.main-content').outerHeight();
      self.loaderHeight = loaderHeight;
    },
    methods: {
      getFavorites() {
        let self = this;
        if (RecipeApi.CancelRequests !== null) {
          RecipeApi.CancelRequests();
        }

        RecipeApi.getFavorites().then(response => {
          self.recipeData = response.data;
          self.isLoading = false;
        })
          .catch(err => {
            setTimeout(function () {
              self.getFavorites();
            }, 5000)
          });
      }
    }
  }
</script>
<style>
  .rounded {
    border-radius: 50%;
    shape-outside: circle();
  }
  .row .noFavourites {
    text-align: center;
    width: 100%;
    margin: 15px 0;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// Favorites.vue?031601fc